import { useTranslation } from 'react-i18next';

import { formValidations } from '@/src/constants/FormValidations';

export const useRulesValidations = () => {
  const { t } = useTranslation();
  const { inputLengths, formRegExp } = formValidations;

  const VALIDATION_RULES = {
    input: {
      required: {
        value: true,
        message: t('FORMS_RULES_MESSAGES.required'),
      },
      minLength: {
        value: inputLengths.min,
        message: t('FORMS_RULES_MESSAGES.minLength'),
      },
      maxLength: {
        value: inputLengths.max,
        message: t('FORMS_RULES_MESSAGES.maxLength'),
      },
      pattern: {
        value: formRegExp.lettersNumbersAndSpecials,
        message: t('FORMS_RULES_MESSAGES.lettersNumbersAndSpecials'),
      },
    },
  };

  return { VALIDATION_RULES };
};
